// extracted by mini-css-extract-plugin
export default {"container":"Waitlist_container__0aeMb","desc":"Waitlist_desc__QMa8Q","graphWrapper":"Waitlist_graphWrapper__7pKPu"};